function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 14C3.1 14 4 13.1 4 12V2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2V12C0 13.1 0.9 14 2 14ZM8 2V12C8 13.1 8.9 14 10 14C11.1 14 12 13.1 12 12V2C12 0.9 11.1 0 10 0C8.9 0 8 0.9 8 2Z",
  fill: "#6D0FA7"
});

const SvgPause = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPause, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause.92b0e00c.svg";
export { ForwardRef as ReactComponent };